import React from 'react';
import { first } from 'lodash';
import { useMassEditModals } from './use-mass-edit-modals';
import {useCoursesPatcher} from '../../../hooks/use-courses-patcher';

export const useEditor = ({
    getInitialValue = () => {},
} = {}) => {
    const { closeModal, selectedCourses: experiences = [] } = useMassEditModals();
    const [ value, setValue ] = React.useState(getInitialValue(first(experiences)));
    const { isBusy, patchCourses } = useCoursesPatcher({ onSuccess: closeModal });
    const save = () => {
        patchCourses(experiences, value);
    };
    return {
        value,
        setValue,
        experiences,
        onClose: closeModal,
        save,
        isBusy
    };
};
